import styled from 'styled-components';
export const Container = styled.section`
    max-width: 800px;
    margin: 0 auto;
    padding: 4rem 2rem;
    text-align: center;
    @media (max-width: 1024px) {
        padding: 4rem 2rem;
    }
    @media (max-width: 600px) {
        padding: 2rem 1rem;
    }
`;

export const Title = styled.h2`
    font-size: 2rem;
    font-weight: bold;
    color: var(--c-brand-ink);
    margin-bottom: 2.4rem;
`;

export const Grid = styled.div`
    display: grid;
    grid-template-columns: repeat(4, 1fr); 
    gap: 1.2rem;

    @media (max-width: 1024px) {
        grid-template-columns: repeat(3, 1fr); 
    }

    @media (max-width: 600px) {
        grid-template-columns: repeat(2, 1fr); 
    }
`;
export const Item = styled.div`
    background: #fff;
    border: 1px solid #ddd; 
    border-radius: 12px;
    padding: 1rem;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
    transition: transform 0.2s ease, border-color 0.2s ease;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;

    &:hover {
        transform: scale(1.05);
        border-color: var(--c-brand-ink); 
    }

    img {
        max-height: 80px;
        object-fit: contain;
        width: 100%;
    }
`;
